import React from "react";
import FieldTypesEnum from "../Enums/FieldTypesEnum";
import TabListTableCellWidthEnum from "../Enums/TabListTableCellWidthEnum";
import Comments from "../Elements/Comments";
import FaIcon from "../Elements/FaIcon";
import LogComponent from "../Elements/LogComponent";
import FreelancerPaymentExportStatusEnum from "../Enums/FreelancerPaymentExportStatusEnum";
import AttachmentsComponent from "../Elements/AttachmentsComponent";
import FreelancerInvoiceAdmin from "../Contents/FreelancerInvoicing/FreelancerInvoices/FreelancerInvoiceAdmin";
import stringHelper from "../Helpers/stringHelper";
import DataTableActionMenu from "../Elements/DataTable/DataTableActionMenu";

export default class FreelancerPaymentExportItem {
  constructor(item) {
    if (item === undefined) {
      this.FreelancerPaymentExportId = null;
      this.OfficeId = "";
      this.PaymentMethod = "";
      this.Status = "";
      this.FileName = "";
      this.AttachmentId = "";
      this.CreatedBy = "";
      this.CreatedOn = "";
      this.OfficeName = "";
      this.CreatedByUserName = "";
      this.NumberOfInvoices = "";
      this.ContentType = "";
    } else {
      this.initialize(item);
    }
  }

  async initialize(item) {
    this.FreelancerPaymentExportId = item.freelancerPaymentExportId;
    this.OfficeId = item.officeId;
    this.PaymentMethod = item.paymentMethod;
    this.Status = item.status;
    this.FileName = item.fileName;
    this.AttachmentId = item.attachmentId;
    this.CreatedBy = item.createdBy;
    this.CreatedOn = item.createdOn;
    this.OfficeName = item.officeName;
    this.CreatedByUserName = item.createdByUserName;
    this.NumberOfInvoices = item.numberOfInvoices;
    this.ContentType = item.contentType;
  }

  static NameOfTheIdField() {
    return "FreelancerPaymentExportId";
  }
  static nameOfTheItemDetailList() {
    return "Vendor Payment Exports";
  }

  static MoneyFields = [""];

  static Currency() {
    return "";
  }

  static MoneyFieldsSecondary = [""];

  static CurrencySecondary() {
    return "";
  }

  static DateFields = [""];

  static BoolFields = [""];

  static FieldsToShowInListTable = [
    {
      tabName: "General",
      tabLabel: "General",
      icon: "fa-solid fa-home",
      data: [
        { name: "FreelancerPaymentExportId", label: "Id", className: "text-center" },
        { name: "OfficeName", label: "Office", className: "text-center" },
        { name: "PaymentMethod", label: "Payment method", className: "text-center" },
        { name: "Status", label: "Status", className: "text-center" },
        { name: "CreatedByUserName", label: "Created by", className: "text-center" },
        { name: "NumberOfInvoices", label: "Number of invoices", className: "text-center" },
      ],
    },
    {
      tabName: "Attachments",
      tabLabel: "Attachments",
      icon: "fa-solid fa-paperclip",
      data: [{ name: FreelancerPaymentExportItem.getAttachmentsContent, label: "Attachments", width: TabListTableCellWidthEnum.TwoLines }],
    },
    {
      tabName: "Comments",
      tabLabel: "Comments",
      icon: "fa-solid fa-comment",
      data: [{ name: FreelancerPaymentExportItem.getCommentsContent, label: "Comments", width: TabListTableCellWidthEnum.TwoLines }],
    },
    {
      tabName: "Log",
      tabLabel: "Log",
      icon: "fa-solid fa-stream",
      data: [{ name: FreelancerPaymentExportItem.getLogContent, label: "Log", width: TabListTableCellWidthEnum.TwoLines }],
    },
  ];

  static getCommentsContent(item) {
    return <Comments entityTypeId={10008} entityId={item.FreelancerPaymentExportId} />;
  }

  static getLogContent(item) {
    return <LogComponent entityType="FreelancerPaymentExport" entityId={item.FreelancerPaymentExportId} />;
  }

  static getAttachmentsContent(item) {
    return <AttachmentsComponent entityTypeId={10008} entityId={item.FreelancerPaymentExportId} enableAddNew={false} />;
  }

  //Meaning of data field:
  //   if type is FieldTypesEnum.DataFieldWithDetails then it is the name of the ID field
  //   if type is FieldTypesEnum.PureDataField then it is the name of the field to show or it is a function
  //			and the field shows the result of this function
  //   if type is FieldTypesEnum.FunctionField then it is the function which will be called by clicking on the labeltext in the cell.
  //   In the following example the FreelancerUserItem.editFunction function is a static variable in this class, so you can change its value
  //   I change the value in the constructor of the FreelancerUserAdmin component
  static FieldsToShowInDataTable() {
    return [
      { label: "Id", orderById: "FreelancerPaymentExportId", data: "FreelancerPaymentExportId", type: FieldTypesEnum.DataFieldWithDetails, minWidth: 20 },
      { label: "Office", orderById: "OfficeName", data: "OfficeName", minWidth: 40 },
      { label: "Payment Method", orderById: "PaymentMethod", data: FreelancerPaymentExportItem.getPaymentMethodCellContent },
      { label: "Status", orderById: "Status", data: "Status" },
      { label: "Created by", orderById: "CreatedByUserName", data: "CreatedByUserName" },
      { label: "FileName", orderById: "FileName", data: FreelancerPaymentExportItem.getFileNameCellContent },
      // {label: "#", orderById: "NumberOfInvoices", data:FreelancerPaymentExportItem.getNumberOfInvoicesCellContent, minWidth: 20},
      { label: " ", orderById: "", data: " ", minWidth: 20 },
      { label: " ", orderById: "", data: FreelancerPaymentExportItem.getActionCellContent, type: FieldTypesEnum.ActionButton, minWidth: 20 },
    ];
  }

  static getPaymentMethodCellContent(item) {
    switch (item.PaymentMethod) {
      case "PayPal":
        return "PayPal";
      case "AliPay":
        return "AliPay";
      case "ChinaBankTransferAbroad":
        return "China Bank Transfer International";
      case "ChinaBankTransferHome":
        return "China Bank Transfer Domestic";
      default:
        break;
    }
    return stringHelper.convertToWords(item.PaymentMethod);
  }

  // static getNumberOfInvoicesCellContent(item)
  // {
  // 	return (
  // 		<Link
  // 			tooltipText={`Number of invoices (${item.NumberOfInvoices})`}
  // 			title="Invoices"
  // 			link={<FreelancerInvoiceAdmin freelancerPaymentExportId={item.FreelancerPaymentExportId} />}
  // 			className="link"
  // 			iconName="fa-solid fa-file-invoice-dollar"
  // 			linktext={item.NumberOfInvoices}
  // 		/>
  // 	);
  // }

  static getFileNameCellContent(item) {
    if (!item.FileName) return null;
    return (
      <FaIcon iconName="fa-solid fa-download" tooltipText="Download Export File" onClick={() => FreelancerPaymentExportItem.clickOnDownloadFile(item)} disabled={!item.FileName} text={item.FileName} />
    );
  }

  static getActionCellContent(item) {
    if (!!item.TimesheetEntryId || !!item.FreelancerInvoiceId) return null;
    return (
      <DataTableActionMenu
        options={[
          {
            tooltipText: `Number of invoices (${item.NumberOfInvoices})`,
            title: "Invoices",
            link: <FreelancerInvoiceAdmin freelancerPaymentExportId={item.FreelancerPaymentExportId} />,
            iconName: "fa-solid fa-file-invoice-dollar",
            text: `Go to the invoices (#${item.NumberOfInvoices})`,
            url: `freelancer_invoices/search?FreelancerPaymentExportId=${item.FreelancerPaymentExportId}`,
          },
          {
            iconName: "fa-solid fa-oven",
            text: "Generate Payment Export File",
            onClick: () => FreelancerPaymentExportItem.clickOnGeneratePaymentExportFileIcon(item),
            disabled: item.Status !== FreelancerPaymentExportStatusEnum.Created || item.NumberOfInvoices < 1,
          },
        ]}
      />
    );
  }

  static clickOnGeneratePaymentExportFileIcon(item) {
    alert("Generate");
  }

  static clickOnDownloadFile(item) {
    alert("Download");
  }
}
